// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common CSS styles for authentication pages */

/* Custom Scrollbar Styles — theme-aware values in tokens.css */


:root {
  /* Color tokens live in src/theme/tokens.css (Cloudlight / Midnight).
     Legacy aliases are defined there so existing CSS keeps working. */

  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-xxl: 3rem;
  
  /* Font sizes */
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-md: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.5rem;
  --font-size-3xl: 1.875rem;
  --font-size-4xl: 2.25rem;
  
  /* Font weights */
  --font-weight-light: 300;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  
  /* Border radius */
  --border-radius-sm: 0.25rem;
  --border-radius-md: 0.375rem;
  --border-radius-lg: 0.5rem;
  --border-radius-xl: 0.75rem;
  --border-radius-2xl: 1rem;
  --border-radius-full: 9999px;
  
  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-normal: 200ms ease;
  --transition-slow: 500ms ease;
}

/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: var(--bg-light);
  color: var(--text-primary);
  line-height: 1.5;
  /* overflow: hidden;  Hide scrollbars on body */
  min-height: 100vh;
}

/* Auth container styles */
.auth-container {
  display: flex;
  min-height: 100vh;
  width: 100%;
  /* box-sizing: border-box; */
  overflow: hidden; /* Hide both horizontal and vertical scrollbars */
  position: relative;
}

/* Left section for background and animation */
.auth-left-section {
  
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100vh;
  background-color: var(--primary-color);
  background-image: linear-gradient(135deg, rgba(67, 97, 238, 0.9), rgba(76, 201, 240, 0.9));
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  padding: var(--spacing-md);
  z-index: 1;
}

/* Right section for auth card */

.auth-right-section,
.auth-card {
  animation: none !important;
  transition: none !important;
  transform: none !important;
  opacity: 1 !important;
}

.auth-right-section {
  position: fixed;
  top: 0;
  right: 0;
  width: 50%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-md);
  background-color: var(--bg-light);
  background-image: radial-gradient(circle at 75% 75%, rgba(76, 201, 240, 0.05) 0%, transparent 50%);
  z-index: 1;
  overflow-y: auto;
}

.loading-text {
  margin-left: 10px;
  color: #666;
  font-style: italic;
}

.project-dropdown:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Animation container */
.animation-container {
  width: 100%;
  height: 100%;
  position: relative;
  margin-bottom: var(--spacing-xl);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: var(--spacing-xl);
}

/* Left section content container */
.auth-left-section-content {
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* Project title */
.project-title {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-md);
  text-align: center;
}

/* Project description */
.project-description {
  font-size: var(--font-size-lg);
  text-align: center;
  max-width: 600px;
  line-height: 1.6;
}

.auth-card {
  width: 100%;
  max-width: 450px;
  max-height: 95vh;
  background-color: var(--bg-white);
  border-radius: var(--border-radius-2xl);
  box-shadow: var(--box-shadow-lg);
  /* overflow-y: auto !important;
  overflow-x: hidden !important; */
  position: relative;
  box-sizing: border-box;
}

.auth-body form,
.wizard-auth-content form {
  width: 100%;
  max-width: 100%;
}

.auth-header {
  padding: var(--spacing-lg) var(--spacing-xl);
  text-align: center;
  position: relative;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.auth-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--bg-gradient);
}

.auth-logo {
  margin-bottom: var(--spacing-md);
  height: 60px;
  width: 60px;
  border-radius: var(--border-radius-full);
  padding: var(--spacing-xs);
  background-color: var(--bg-gray-50);
  box-shadow: var(--box-shadow-sm);
}

.auth-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  margin-bottom: var(--spacing-xs);
}

.auth-subtitle {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  max-width: 300px;
  margin: 0 auto;
}

.auth-body {
  padding: var(--spacing-lg) var(--spacing-xl);
  overflow-x: hidden;
  word-wrap: break-word;
}

.auth-login-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  border-bottom: 2px solid var(--border-color);
}

.auth-login-tab {
  flex: 1 1;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.auth-login-tab:hover {
  color: var(--text-primary);
  background: rgba(67, 97, 238, 0.02);
}

.auth-login-tab.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
  background: rgba(67, 97, 238, 0.05);
}

.auth-footer {
  padding: var(--spacing-lg) var(--spacing-xl);
  text-align: center;
  background-color: var(--bg-gray-50);
  border-top: 1px solid var(--border-color);
}

/* Form styles */
.form-group {
  margin-bottom: var(--spacing-lg);
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-xs);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.form-input {
  width: 100%;
  padding: var(--spacing-md) var(--spacing-lg);
  font-size: var(--font-size-md);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  background-color: var(--bg-white);
  transition: all var(--transition-fast); /* Removes default styling on iOS */
  appearance: none;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
}

.form-input::placeholder {
  color: var(--text-muted);
}

.form-error {
  margin-top: var(--spacing-xs);
  font-size: var(--font-size-xs);
  color: var(--danger-color);
  word-break: break-word;
  display: flex;
  align-items: center;
}

.form-error::before {
  content: "⚠️";
  margin-right: var(--spacing-xs);
}

.form-text {
  margin-top: var(--spacing-xs);
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
}

/* Resend verification email */
.resend-verification-info {
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
}

.resend-verification-info-title {
  color: #1e40af;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0 0 12px;
  text-align: center;
}

.resend-verification-hint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
  margin: 12px 0 0;
  text-align: center;
}

.resend-verification-link {
  background: none;
  border: none;
  color: #4285f4;
  cursor: pointer;
  font-size: inherit;
  font-weight: 600;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.resend-verification-link:hover:not(:disabled) {
  color: #3574e2;
}

.resend-verification-link:disabled {
  color: #94a3b8;
  cursor: not-allowed;
  text-decoration: none;
}

.resend-verification-note {
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
  margin: 8px 0 0;
  text-align: center;
}

.resend-verification-success {
  color: #16a34a;
  font-size: 13px;
  line-height: 1.4;
  margin: 8px 0 0;
  text-align: center;
}

.resend-verification-error {
  color: var(--danger-color);
  font-size: 13px;
  line-height: 1.4;
  margin: 8px 0 0;
  text-align: center;
}

.resend-verification .form-group {
  margin-bottom: 0;
}

/* Button styles */
.btn {
  display: inline-block;
  padding: var(--spacing-md) var(--spacing-lg);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: var(--border-radius-lg);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent; /* Removes tap highlight on mobile */
  touch-action: manipulation; /* Improves touch behavior */
}

.btn-block {
  display: block;
  width: 100%;
}

/* Auth submit buttons — proportional sizing for login/signup forms */
.auth-body .btn-primary.btn-block,
.wizard-auth-content .btn-primary.btn-block {
  width: 100%;
  max-width: 100%;
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  border-radius: 0.75rem;
  box-sizing: border-box;
  box-shadow: none;
}

.auth-body .btn-primary.btn-block:hover,
.wizard-auth-content .btn-primary.btn-block:hover {
  box-shadow: none;
  transform: none;
}

.auth-body .btn-primary.btn-block:active,
.wizard-auth-content .btn-primary.btn-block:active {
  transform: none;
  box-shadow: none;
}

.btn-primary {
  background: var(--bg-gradient);
  color: var(--white);
  box-shadow: 0 4px 6px rgba(67, 97, 238, 0.25); /* Removes default styling on iOS */
  appearance: none;
}

.btn-primary:hover {
  box-shadow: 0 6px 8px rgba(67, 97, 238, 0.35);
  transform: translateY(-1px);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(67, 97, 238, 0.2);
}

.btn-secondary {
  background-color: var(--secondary-color);
  color: var(--white);
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
}

.btn-outline:hover {
  background-color: var(--bg-gray-100);
}

.btn-link {
  background-color: transparent;
  color: var(--primary-color);
  padding: 0;
  text-decoration: none;
  font-weight: var(--font-weight-medium);
}

.btn-link:hover {
  text-decoration: underline;
}

/* Utility classes */
.text-center {
  text-align: center;
}

.text-primary {
  color: var(--primary-color);
}

.text-secondary {
  color: var(--text-secondary);
}

.text-muted {
  color: var(--text-muted);
}

.text-danger {
  color: var(--danger-color);
}

.mt-1 {
  margin-top: var(--spacing-xs);
}

.mt-2 {
  margin-top: var(--spacing-sm);
}

.mt-3 {
  margin-top: var(--spacing-md);
}

.mt-4 {
  margin-top: var(--spacing-lg);
}

.mb-1 {
  margin-bottom: var(--spacing-xs);
}

.mb-2 {
  margin-bottom: var(--spacing-sm);
}

.mb-3 {
  margin-bottom: var(--spacing-md);
}

.mb-4 {
  margin-bottom: var(--spacing-lg);
}

.d-flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

/* Divider with text */
.divider {
  display: flex;
  align-items: center;
  margin: var(--spacing-lg) 0;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

.divider::before,
.divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background-color: var(--border-color);
}

.divider::before {
  margin-right: var(--spacing-md);
}

.divider::after {
  margin-left: var(--spacing-md);
}


.remember-me-option {
  display: flex;
  align-items: flex-start;
  margin: 15px 0;
  gap: 8px;
  width: 100%;
}

.remember-me-checkbox {
  margin: 0;
  margin-top: 3px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.remember-me-label {
  font-size: 14px;
  line-height: 1.5;
  display: block;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.btn-link {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: #0066cc;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  display: inline;
  line-height: inherit;
  vertical-align: baseline;
}

.btn-link:hover {
  color: #004499;
  text-decoration: none;
}

/* Form error styles */
.form-error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
}

/* Terms and Privacy Policy specific styling */
.terms-text {
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Social login buttons */
.social-button {
 
  margin-bottom: var(--spacing-lg);
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--border-color);
  min-width: 60px;
  min-height: 50px;
}

.social-buttons{
   display: flex;
  justify-content: space-around;
}

.social-btn {
  flex: 1 1;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-md);
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--border-color);
  background-color: var(--bg-white);
  transition: all var(--transition-fast);
  box-shadow: var(--box-shadow-sm);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.social-btn:hover {
  background-color: var(--bg-gray-50);
  transform: translateY(-2px);
  box-shadow: var(--box-shadow);
}

.social-btn:active {
  transform: translateY(0);
}

.social-btn svg {
  height: 24px;
  width: 24px;
  color: var(--text-secondary);
}

/* Checkbox and radio styles */
.form-check {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--spacing-md);
  position: relative;
  flex-wrap: wrap;
}

.form-check-input {
  margin-right: var(--spacing-sm);
  margin-top: 0.2rem;
  appearance: none;
  -webkit-appearance: none;
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  background-color: var(--bg-white);
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
}

.form-check-input:checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.form-check-input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0.6rem;
  height: 0.6rem;
  background-color: var(--white);
  border-radius: 1px;
}

.form-check-label {
  font-size: var(--font-size-sm);
  color: var(--text-primary);
  cursor: pointer;
  flex: 1 1;
}

/* Success state */
.success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 0 auto var(--spacing-lg);
  border-radius: var(--border-radius-full);
  background-color: rgba(76, 201, 240, 0.1);
}

.success-icon svg {
  color: var(--success-color);
}

.success-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-sm);
  color: var(--text-primary);
}

.success-message {
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .auth-card {
    max-width: 90%;
  }
  
  .form-input {
    padding: var(--spacing-md) var(--spacing-md);
  }
  
  .btn {
    padding: var(--spacing-md) var(--spacing-md);
  }
}

@media (max-width: 576px) {
  .auth-card {
    max-width: 100%;
    border-radius: var(--border-radius-lg);
    margin: var(--spacing-sm);
  }
  
  .social-buttons {
    flex-direction: column;
    gap: var(--spacing-sm);
  }
  
  .auth-header,
  .auth-body,
  .auth-footer {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }
  
  .auth-title {
    font-size: var(--font-size-xl);
  }
  
  .auth-subtitle {
    font-size: var(--font-size-xs);
  }
  
  .form-group {
    margin-bottom: var(--spacing-md);
  }
  
  .form-check {
    align-items: flex-start;
  }
  
  .form-check-label {
    font-size: var(--font-size-xs);
  }
}

/* Modern additions */
.floating-label {
  position: relative;
}

.floating-label .form-input {
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
}

.floating-label .form-label {
  position: absolute;
  top: 0.75rem;
  left: 1rem;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  pointer-events: none;
}

/* Password strength indicator */
.password-strength {
  display: flex;
  margin-top: var(--spacing-xs);
  gap: 4px;
}

.strength-bar {
  height: 4px;
  flex: 1 1;
  background-color: var(--border-color);
  border-radius: var(--border-radius-full);
}

.strength-bar.active {
  background-color: var(--danger-color);
}

.strength-bar.active.medium {
  background-color: var(--warning-color);
}

.strength-bar.active.strong {
  background-color: var(--success-color);
}

/* Animated elements */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.auth-card {
  animation: fadeIn 0.5s ease-out;
}

.social-btn, .btn-primary, .form-input {
  transition: all 0.3s ease;
}

/* Card design enhancements */
.auth-card {
  position: relative;
  overflow: visible;
}

.auth-card::before {
  content: "";
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  background: linear-gradient(135deg, rgba(67, 97, 238, 0.1), rgba(76, 201, 240, 0.1));
  border-radius: calc(var(--border-radius-2xl) + 5px);
  z-index: -1;
  opacity: 0.7;
}

/* Responsive styles for auth container */
@media (max-width: 768px) {
  .auth-container {
    flex-direction: column;
    overflow-y: auto;
  }
  
  .auth-left-section {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    padding: 2rem 1rem;
  }
  
  .auth-right-section {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 60vh;
    padding: 2rem 1rem;
    overflow-y: auto;
  }
  
  .auth-card {
    max-width: 100%;
    box-shadow: var(--box-shadow-md);
    border-radius: var(--border-radius-2xl);
    margin: 0 auto;
  }
  
  .auth-header {
    padding: 1.5rem 1.5rem;
    min-height: 100px;
  }
  
  .auth-logo {
    height: 50px;
    width: 50px;
  }
  
  .auth-title {
    font-size: 1.5rem;
  }
  
  .auth-body {
    padding: 1rem 1.5rem;
  }
  
  .social-buttons {
    flex-wrap: nowrap;
    gap: 0.75rem;
  }
  
  .social-btn {
    min-width: 50px;
    padding: 0.75rem 0.5rem;
  }
}

@media (max-width: 480px) {
  .auth-header {
    padding: 1rem;
    min-height: 80px;
  }
  
  .auth-logo {
    height: 40px;
    width: 40px;
    margin-bottom: 0.5rem;
  }
  
  .auth-title {
    font-size: 1.25rem;
    margin-bottom: 0.25rem;
  }
  
  .auth-subtitle {
    font-size: 0.8rem;
  }
  
  .auth-body {
    padding: 1rem;
  }
  
  .form-input {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }
  
  .auth-body .btn-primary.btn-block,
  .wizard-auth-content .btn-primary.btn-block {
    padding: 0.625rem 0.875rem;
    font-size: 0.8125rem;
  }
  
  .social-buttons {
    gap: 0.5rem;
  }
  
  .remember-me-label {
    font-size: 0.8rem;
    line-height: 1.4;
  }
  
  .btn-link {
    font-size: 0.8rem;
  }
}

/* Tablet landscape and larger phones */
@media (min-width: 481px) and (max-width: 1024px) {
  .auth-card {
    max-width: 500px;
  }
  
  .auth-left-section {
    height: 100vh;
  }
  
  .auth-right-section {
    padding: 2rem;
  }
}

/* Very small devices (phones under 360px) */
@media (max-width: 360px) {
  .auth-card {
    max-height: 95vh;
    margin: 1rem 0.5rem;
    overflow-y: auto;
  }
  
  .remember-me-label {
    font-size: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .auth-header {
    padding: 0.75rem;
    min-height: 70px;
  }
  
  .auth-logo {
    height: 35px;
    width: 35px;
    margin-bottom: 0.5rem;
  }
  
  .auth-title {
    font-size: 1.125rem;
    margin-bottom: 0.25rem;
  }
  
  .auth-subtitle {
    font-size: 0.75rem;
  }
  
  .auth-body {
    padding: 0.75rem;
  }
  
  .form-group {
    margin-bottom: 0.75rem;
  }
  
  .auth-body .btn-primary.btn-block,
  .wizard-auth-content .btn-primary.btn-block {
    font-size: 0.8125rem;
    padding: 0.625rem 0.75rem;
  }
  
  .social-buttons {
    gap: 0.25rem;
  }
  
  .social-btn {
    padding: 0.5rem 0.25rem;
    min-width: 45px;
  }
}

/* Orientation-specific adjustments */
@media screen and (orientation: landscape) and (max-width: 900px) {
  .auth-container {
    flex-direction: row;
  }
  
  .auth-left-section {
    display: none;
  }
  
  .auth-right-section {
    width: 100%;
    padding: 1rem;
  }
  
  .auth-card {
    max-width: 400px;
    margin: 0 auto;
  }
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
  gap: 0.5rem;
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
}

.pageNumbers {
  display: flex;
  gap: 0.5rem;
}

.pageItem {
  background: transparent;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95rem;
  min-width: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pageItem:hover:not(.active):not(.disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}

.pageItem.active {
  background: var(--color-secondary-dark);
  color: var(--primary-color);
  border-color: #0070f3;
  font-weight: 500;
  cursor: default;
}

.pageItem.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: transparent !important;
}

.navButton {
  padding: 0.5rem 1rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: var(--primary-color);
  font-weight: 500;
}

.navButton:hover:not(.disabled) {
  background: #e9ecef;
}

.chevron {
  font-size: 1.1em;
  margin: 0 2px;
  color: var(--primary-color);
}

.pageDots {
  padding: 0.5rem 0.25rem;
  color: #6c757d;
  display: flex;
  align-items: flex-end;
}

@media (max-width: 768px) {
  .pagination {
    flex-wrap: wrap;
    gap: 0.4rem;
  }
  
  .pageItem {
    padding: 0.4rem 0.6rem;
    min-width: 36px;
    font-size: 0.9rem;
  }

  .navButton {
    padding: 0.4rem 0.8rem;
  }
}

.center-loader {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

 .form-group select.form-input {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem;
  padding-right: 2.5rem;
}

 .dark .form-group select.form-input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}


.entity-item {
  position: relative; 
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #fff;
  transition: all 0.2s ease;
}

.entity-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; 
  margin-bottom: 8px;
}

.entity-name {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  flex-grow: 1;
}

.entity-actions {
  display: flex;
  gap: 8px;
  /* position: absolute; */
  top: 10px;
  right: 10px;
}

.action-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
}

.action-btn:hover {
  color: #333;
}

.action-btn.edit:hover {
  color: #1a73e8;
}

.action-btn.delete:hover {
  color: #d32f2f;
}


.status-badge {
  margin-left: auto; 
}


.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 15px;
}

.add-sprint-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
}

.add-sprint-btn:hover {
  color: #0d47a1;
}

/* React Toast Custom Styles */
.toastContainer {
  z-index: 20000 !important;
  top: 80px !important;
  position: fixed !important;
  right: 20px !important;
  left: auto !important;
  width: auto !important;
  max-width: 100vw !important;
  overflow-x: hidden !important;
}

.toastContainer.top-right {
  top: 80px !important;
  right: 20px !important;
  left: auto !important;
  width: auto !important;
  max-width: 100vw !important;
  overflow-x: hidden !important;
}

.toast {
  z-index: 9999 !important;
  background: #28a745 !important;
  color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  margin-bottom: 12px !important;
  min-width: 320px !important;
  max-width: 400px !important;
  padding: 16px 20px !important;
  border: none !important;
  display: flex !important;
  align-items: flex-start !important;
  position: relative !important;
  overflow: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
}

.toast .icon {
  margin-right: 12px !important;
  flex-shrink: 0 !important;
  width: 20px !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.toast .icon svg {
  width: 18px !important;
  height: 18px !important;
  fill: white !important;
}

.toast .content {
  flex: 1 1 !important;
  padding: 0 !important;
  margin: 0 12px 0 0 !important;
}

.toast .content p {
  margin: 0 !important;
  padding: 0 !important;
  color: white !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  font-weight: 500 !important;
}

/* Close button styling */
.toast .close {
  flex-shrink: 0 !important;
  width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  border-radius: 50% !important;
  transition: all 0.2s ease !important;
  background: rgba(255, 255, 255, 0.1) !important;
  margin-left: 8px !important;
}

.toast .close:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}

.toast .close svg {
  width: 14px !important;
  height: 14px !important;
  fill: rgba(255, 255, 255, 0.8) !important;
}

.toast .close:hover svg {
  fill: white !important;
}

/* Success Toast */
.toast.success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
}

/* Error Toast */
.toast.error {
  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%) !important;
}

/* Warning Toast */
.toast.warning {
  background: linear-gradient(135deg, #ffc107 0%, #f39c12 100%) !important;
  color: #333 !important;
}

.toast.warning .content p {
  color: #333 !important;
}

.toast.warning .icon svg {
  fill: #333 !important;
}

.toast.warning .close {
  background: rgba(0, 0, 0, 0.1) !important;
}

.toast.warning .close:hover {
  background: rgba(0, 0, 0, 0.2) !important;
}

.toast.warning .close svg {
  fill: rgba(0, 0, 0, 0.6) !important;
}

.toast.warning .close:hover svg {
  fill: #333 !important;
}

/* Info Toast */
.toast.info {
  background: linear-gradient(135deg, #17a2b8 0%, #3498db 100%) !important;
}

/* Default Toast */
.toast.default {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;
}

/* Slide-in animation */
.toast {
  animation: slideInRight 0.3s ease-out !important;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%) !important;
    opacity: 0 !important;
  }
  to {
    transform: translateX(0) !important;
    opacity: 1 !important;
  }
}

/* Slide-out animation */
.toast.toast-exit {
  animation: slideOutRight 0.3s ease-in !important;
}

@keyframes slideOutRight {
  from {
    transform: translateX(0) !important;
    opacity: 1 !important;
  }
  to {
    transform: translateX(100%) !important;
    opacity: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,+DAA+D;;;AAG/D;EACE;sEACoE;;EAEpE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;;EAE5B,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iJAAiJ;EACjJ,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB,EAAE,iDAAiD;EACnE,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,sCAAsC;EACtC,0FAA0F;EAC1F,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,gCAAgC;;AAEhC;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;EACjC,kGAAkG;EAClG,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;EAChC;kCACgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,0BAA0B;EAC1B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,8BAA8B;EAC9B,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,sCAAsC,EACZ,mCAAmC;EAC7D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,wCAAwC,EAAE,oCAAoC;EAC9E,0BAA0B,EAAE,4BAA4B;AAC1D;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,qEAAqE;AACrE;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C,EACnB,mCAAmC;EAC7D,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,UAAU;EACV,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;;EAEE,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;GAEG,aAAa;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,sCAAsC;EACtC,qCAAqC;EACrC,iCAAiC;EACjC,sCAAsC;EACtC,gCAAgC;EAChC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EAKE,wBAAwB;AAH1B;;AAMA;EACE,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,SAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,eAAe;IACf,sCAAsC;IACtC,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;;IAGE,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAO;EACP,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,mDAAmD;EACnD,WAAW;EACX,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,uCAAuC;IACvC,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;CAEC;EAGC,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;EACrB,qBAAqB;AACvB;;CAEC;EACC,yDAAoR;AACtR;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,wBAAwB;EACxB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,qDAAqD;EACrD,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,wEAAwE;AAC1E;;AAEA,gBAAgB;AAChB;EACE,wEAAwE;AAC1E;;AAEA,kBAAkB;AAClB;EACE,wEAAwE;EACxE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,wEAAwE;AAC1E;;AAEA,kBAAkB;AAClB;EACE,wEAAwE;AAC1E;;AAEA,uBAAuB;AACvB;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,sCAAsC;IACtC,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF;;AAEA,wBAAwB;AACxB;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,mCAAmC;IACnC,qBAAqB;EACvB;EACA;IACE,sCAAsC;IACtC,qBAAqB;EACvB;AACF","sourcesContent":["/* Common CSS styles for authentication pages */\n\n/* Custom Scrollbar Styles — theme-aware values in tokens.css */\n\n\n:root {\n  /* Color tokens live in src/theme/tokens.css (Cloudlight / Midnight).\n     Legacy aliases are defined there so existing CSS keeps working. */\n\n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-xxl: 3rem;\n  \n  /* Font sizes */\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-md: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-2xl: 1.5rem;\n  --font-size-3xl: 1.875rem;\n  --font-size-4xl: 2.25rem;\n  \n  /* Font weights */\n  --font-weight-light: 300;\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  \n  /* Border radius */\n  --border-radius-sm: 0.25rem;\n  --border-radius-md: 0.375rem;\n  --border-radius-lg: 0.5rem;\n  --border-radius-xl: 0.75rem;\n  --border-radius-2xl: 1rem;\n  --border-radius-full: 9999px;\n  \n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-normal: 200ms ease;\n  --transition-slow: 500ms ease;\n}\n\n/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  background-color: var(--bg-light);\n  color: var(--text-primary);\n  line-height: 1.5;\n  /* overflow: hidden;  Hide scrollbars on body */\n  min-height: 100vh;\n}\n\n/* Auth container styles */\n.auth-container {\n  display: flex;\n  min-height: 100vh;\n  width: 100%;\n  /* box-sizing: border-box; */\n  overflow: hidden; /* Hide both horizontal and vertical scrollbars */\n  position: relative;\n}\n\n/* Left section for background and animation */\n.auth-left-section {\n  \n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 100vh;\n  background-color: var(--primary-color);\n  background-image: linear-gradient(135deg, rgba(67, 97, 238, 0.9), rgba(76, 201, 240, 0.9));\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  padding: var(--spacing-md);\n  z-index: 1;\n}\n\n/* Right section for auth card */\n\n.auth-right-section,\n.auth-card {\n  animation: none !important;\n  transition: none !important;\n  transform: none !important;\n  opacity: 1 !important;\n}\n\n.auth-right-section {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-md);\n  background-color: var(--bg-light);\n  background-image: radial-gradient(circle at 75% 75%, rgba(76, 201, 240, 0.05) 0%, transparent 50%);\n  z-index: 1;\n  overflow-y: auto;\n}\n\n.loading-text {\n  margin-left: 10px;\n  color: #666;\n  font-style: italic;\n}\n\n.project-dropdown:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Animation container */\n.animation-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  margin-bottom: var(--spacing-xl);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: var(--spacing-xl);\n}\n\n/* Left section content container */\n.auth-left-section-content {\n  padding: var(--spacing-xl);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n/* Project title */\n.project-title {\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-bold);\n  margin-bottom: var(--spacing-md);\n  text-align: center;\n}\n\n/* Project description */\n.project-description {\n  font-size: var(--font-size-lg);\n  text-align: center;\n  max-width: 600px;\n  line-height: 1.6;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 450px;\n  max-height: 95vh;\n  background-color: var(--bg-white);\n  border-radius: var(--border-radius-2xl);\n  box-shadow: var(--box-shadow-lg);\n  /* overflow-y: auto !important;\n  overflow-x: hidden !important; */\n  position: relative;\n  box-sizing: border-box;\n}\n\n.auth-body form,\n.wizard-auth-content form {\n  width: 100%;\n  max-width: 100%;\n}\n\n.auth-header {\n  padding: var(--spacing-lg) var(--spacing-xl);\n  text-align: center;\n  position: relative;\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.auth-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--bg-gradient);\n}\n\n.auth-logo {\n  margin-bottom: var(--spacing-md);\n  height: 60px;\n  width: 60px;\n  border-radius: var(--border-radius-full);\n  padding: var(--spacing-xs);\n  background-color: var(--bg-gray-50);\n  box-shadow: var(--box-shadow-sm);\n}\n\n.auth-title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-xs);\n}\n\n.auth-subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.auth-body {\n  padding: var(--spacing-lg) var(--spacing-xl);\n  overflow-x: hidden;\n  word-wrap: break-word;\n}\n\n.auth-login-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.auth-login-tab {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.auth-login-tab:hover {\n  color: var(--text-primary);\n  background: rgba(67, 97, 238, 0.02);\n}\n\n.auth-login-tab.active {\n  color: var(--primary-color);\n  border-bottom-color: var(--primary-color);\n  background: rgba(67, 97, 238, 0.05);\n}\n\n.auth-footer {\n  padding: var(--spacing-lg) var(--spacing-xl);\n  text-align: center;\n  background-color: var(--bg-gray-50);\n  border-top: 1px solid var(--border-color);\n}\n\n/* Form styles */\n.form-group {\n  margin-bottom: var(--spacing-lg);\n}\n\n.form-label {\n  display: block;\n  margin-bottom: var(--spacing-xs);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n.form-input {\n  width: 100%;\n  padding: var(--spacing-md) var(--spacing-lg);\n  font-size: var(--font-size-md);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  background-color: var(--bg-white);\n  transition: all var(--transition-fast);\n  -webkit-appearance: none; /* Removes default styling on iOS */\n  appearance: none;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);\n}\n\n.form-input::placeholder {\n  color: var(--text-muted);\n}\n\n.form-error {\n  margin-top: var(--spacing-xs);\n  font-size: var(--font-size-xs);\n  color: var(--danger-color);\n  word-break: break-word;\n  display: flex;\n  align-items: center;\n}\n\n.form-error::before {\n  content: \"⚠️\";\n  margin-right: var(--spacing-xs);\n}\n\n.form-text {\n  margin-top: var(--spacing-xs);\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n}\n\n/* Resend verification email */\n.resend-verification-info {\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n}\n\n.resend-verification-info-title {\n  color: #1e40af;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0 0 12px;\n  text-align: center;\n}\n\n.resend-verification-hint {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 12px 0 0;\n  text-align: center;\n}\n\n.resend-verification-link {\n  background: none;\n  border: none;\n  color: #4285f4;\n  cursor: pointer;\n  font-size: inherit;\n  font-weight: 600;\n  padding: 0;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.resend-verification-link:hover:not(:disabled) {\n  color: #3574e2;\n}\n\n.resend-verification-link:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.resend-verification-note {\n  color: #94a3b8;\n  font-size: 12px;\n  line-height: 1.4;\n  margin: 8px 0 0;\n  text-align: center;\n}\n\n.resend-verification-success {\n  color: #16a34a;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 8px 0 0;\n  text-align: center;\n}\n\n.resend-verification-error {\n  color: var(--danger-color);\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 8px 0 0;\n  text-align: center;\n}\n\n.resend-verification .form-group {\n  margin-bottom: 0;\n}\n\n/* Button styles */\n.btn {\n  display: inline-block;\n  padding: var(--spacing-md) var(--spacing-lg);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  text-align: center;\n  text-decoration: none;\n  border: none;\n  border-radius: var(--border-radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent; /* Removes tap highlight on mobile */\n  touch-action: manipulation; /* Improves touch behavior */\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n/* Auth submit buttons — proportional sizing for login/signup forms */\n.auth-body .btn-primary.btn-block,\n.wizard-auth-content .btn-primary.btn-block {\n  width: 100%;\n  max-width: 100%;\n  padding: 0.625rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25;\n  border-radius: 0.75rem;\n  box-sizing: border-box;\n  box-shadow: none;\n}\n\n.auth-body .btn-primary.btn-block:hover,\n.wizard-auth-content .btn-primary.btn-block:hover {\n  box-shadow: none;\n  transform: none;\n}\n\n.auth-body .btn-primary.btn-block:active,\n.wizard-auth-content .btn-primary.btn-block:active {\n  transform: none;\n  box-shadow: none;\n}\n\n.btn-primary {\n  background: var(--bg-gradient);\n  color: var(--white);\n  box-shadow: 0 4px 6px rgba(67, 97, 238, 0.25);\n  -webkit-appearance: none; /* Removes default styling on iOS */\n  appearance: none;\n}\n\n.btn-primary:hover {\n  box-shadow: 0 6px 8px rgba(67, 97, 238, 0.35);\n  transform: translateY(-1px);\n}\n\n.btn-primary:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(67, 97, 238, 0.2);\n}\n\n.btn-secondary {\n  background-color: var(--secondary-color);\n  color: var(--white);\n}\n\n.btn-secondary:hover {\n  background-color: #5a6268;\n}\n\n.btn-outline {\n  background-color: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n}\n\n.btn-outline:hover {\n  background-color: var(--bg-gray-100);\n}\n\n.btn-link {\n  background-color: transparent;\n  color: var(--primary-color);\n  padding: 0;\n  text-decoration: none;\n  font-weight: var(--font-weight-medium);\n}\n\n.btn-link:hover {\n  text-decoration: underline;\n}\n\n/* Utility classes */\n.text-center {\n  text-align: center;\n}\n\n.text-primary {\n  color: var(--primary-color);\n}\n\n.text-secondary {\n  color: var(--text-secondary);\n}\n\n.text-muted {\n  color: var(--text-muted);\n}\n\n.text-danger {\n  color: var(--danger-color);\n}\n\n.mt-1 {\n  margin-top: var(--spacing-xs);\n}\n\n.mt-2 {\n  margin-top: var(--spacing-sm);\n}\n\n.mt-3 {\n  margin-top: var(--spacing-md);\n}\n\n.mt-4 {\n  margin-top: var(--spacing-lg);\n}\n\n.mb-1 {\n  margin-bottom: var(--spacing-xs);\n}\n\n.mb-2 {\n  margin-bottom: var(--spacing-sm);\n}\n\n.mb-3 {\n  margin-bottom: var(--spacing-md);\n}\n\n.mb-4 {\n  margin-bottom: var(--spacing-lg);\n}\n\n.d-flex {\n  display: flex;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.align-center {\n  align-items: center;\n}\n\n/* Divider with text */\n.divider {\n  display: flex;\n  align-items: center;\n  margin: var(--spacing-lg) 0;\n  color: var(--text-muted);\n  font-size: var(--font-size-sm);\n}\n\n.divider::before,\n.divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background-color: var(--border-color);\n}\n\n.divider::before {\n  margin-right: var(--spacing-md);\n}\n\n.divider::after {\n  margin-left: var(--spacing-md);\n}\n\n\n.remember-me-option {\n  display: flex;\n  align-items: flex-start;\n  margin: 15px 0;\n  gap: 8px;\n  width: 100%;\n}\n\n.remember-me-checkbox {\n  margin: 0;\n  margin-top: 3px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.remember-me-label {\n  font-size: 14px;\n  line-height: 1.5;\n  display: block;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  color: #0066cc;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  display: inline;\n  line-height: inherit;\n  vertical-align: baseline;\n}\n\n.btn-link:hover {\n  color: #004499;\n  text-decoration: none;\n}\n\n/* Form error styles */\n.form-error {\n  color: #d32f2f;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* Terms and Privacy Policy specific styling */\n.terms-text {\n  display: inline;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n/* Social login buttons */\n.social-button {\n \n  margin-bottom: var(--spacing-lg);\n  border-radius: var(--border-radius-lg);\n  border: 1px solid var(--border-color);\n  min-width: 60px;\n  min-height: 50px;\n}\n\n.social-buttons{\n  display: flex;\n   display: flex;\n  justify-content: space-around;\n}\n\n.social-btn {\n  flex: 1 1;\n  min-width: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-md);\n  border-radius: var(--border-radius-lg);\n  border: 1px solid var(--border-color);\n  background-color: var(--bg-white);\n  transition: all var(--transition-fast);\n  box-shadow: var(--box-shadow-sm);\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.social-btn:hover {\n  background-color: var(--bg-gray-50);\n  transform: translateY(-2px);\n  box-shadow: var(--box-shadow);\n}\n\n.social-btn:active {\n  transform: translateY(0);\n}\n\n.social-btn:active {\n  transform: translateY(0);\n}\n\n.social-btn svg {\n  height: 24px;\n  width: 24px;\n  color: var(--text-secondary);\n}\n\n/* Checkbox and radio styles */\n.form-check {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-md);\n  position: relative;\n  flex-wrap: wrap;\n}\n\n.form-check-input {\n  margin-right: var(--spacing-sm);\n  margin-top: 0.2rem;\n  appearance: none;\n  -webkit-appearance: none;\n  width: 1.2rem;\n  height: 1.2rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  background-color: var(--bg-white);\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.form-check-input:checked {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.form-check-input:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 0.6rem;\n  height: 0.6rem;\n  background-color: var(--white);\n  border-radius: 1px;\n}\n\n.form-check-label {\n  font-size: var(--font-size-sm);\n  color: var(--text-primary);\n  cursor: pointer;\n  flex: 1;\n}\n\n/* Success state */\n.success-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  margin: 0 auto var(--spacing-lg);\n  border-radius: var(--border-radius-full);\n  background-color: rgba(76, 201, 240, 0.1);\n}\n\n.success-icon svg {\n  color: var(--success-color);\n}\n\n.success-title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  margin-bottom: var(--spacing-sm);\n  color: var(--text-primary);\n}\n\n.success-message {\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-lg);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .auth-card {\n    max-width: 90%;\n  }\n  \n  .form-input {\n    padding: var(--spacing-md) var(--spacing-md);\n  }\n  \n  .btn {\n    padding: var(--spacing-md) var(--spacing-md);\n  }\n}\n\n@media (max-width: 576px) {\n  .auth-card {\n    max-width: 100%;\n    border-radius: var(--border-radius-lg);\n    margin: var(--spacing-sm);\n  }\n  \n  .social-buttons {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n  }\n  \n  .auth-header,\n  .auth-body,\n  .auth-footer {\n    padding-left: var(--spacing-lg);\n    padding-right: var(--spacing-lg);\n  }\n  \n  .auth-title {\n    font-size: var(--font-size-xl);\n  }\n  \n  .auth-subtitle {\n    font-size: var(--font-size-xs);\n  }\n  \n  .form-group {\n    margin-bottom: var(--spacing-md);\n  }\n  \n  .form-check {\n    align-items: flex-start;\n  }\n  \n  .form-check-label {\n    font-size: var(--font-size-xs);\n  }\n}\n\n/* Modern additions */\n.floating-label {\n  position: relative;\n}\n\n.floating-label .form-input {\n  padding-top: 1.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.floating-label .form-label {\n  position: absolute;\n  top: 0.75rem;\n  left: 1rem;\n  font-size: var(--font-size-xs);\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n/* Password strength indicator */\n.password-strength {\n  display: flex;\n  margin-top: var(--spacing-xs);\n  gap: 4px;\n}\n\n.strength-bar {\n  height: 4px;\n  flex: 1;\n  background-color: var(--border-color);\n  border-radius: var(--border-radius-full);\n}\n\n.strength-bar.active {\n  background-color: var(--danger-color);\n}\n\n.strength-bar.active.medium {\n  background-color: var(--warning-color);\n}\n\n.strength-bar.active.strong {\n  background-color: var(--success-color);\n}\n\n/* Animated elements */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.auth-card {\n  animation: fadeIn 0.5s ease-out;\n}\n\n.social-btn, .btn-primary, .form-input {\n  transition: all 0.3s ease;\n}\n\n/* Card design enhancements */\n.auth-card {\n  position: relative;\n  overflow: visible;\n}\n\n.auth-card::before {\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  left: -5px;\n  right: -5px;\n  bottom: -5px;\n  background: linear-gradient(135deg, rgba(67, 97, 238, 0.1), rgba(76, 201, 240, 0.1));\n  border-radius: calc(var(--border-radius-2xl) + 5px);\n  z-index: -1;\n  opacity: 0.7;\n}\n\n/* Responsive styles for auth container */\n@media (max-width: 768px) {\n  .auth-container {\n    flex-direction: column;\n    overflow-y: auto;\n  }\n  \n  .auth-left-section {\n    position: relative;\n    width: 100%;\n    height: 40vh;\n    min-height: 300px;\n    padding: 2rem 1rem;\n  }\n  \n  .auth-right-section {\n    position: relative;\n    width: 100%;\n    height: auto;\n    min-height: 60vh;\n    padding: 2rem 1rem;\n    overflow-y: auto;\n  }\n  \n  .auth-card {\n    max-width: 100%;\n    box-shadow: var(--box-shadow-md);\n    border-radius: var(--border-radius-2xl);\n    margin: 0 auto;\n  }\n  \n  .auth-header {\n    padding: 1.5rem 1.5rem;\n    min-height: 100px;\n  }\n  \n  .auth-logo {\n    height: 50px;\n    width: 50px;\n  }\n  \n  .auth-title {\n    font-size: 1.5rem;\n  }\n  \n  .auth-body {\n    padding: 1rem 1.5rem;\n  }\n  \n  .social-buttons {\n    flex-wrap: nowrap;\n    gap: 0.75rem;\n  }\n  \n  .social-btn {\n    min-width: 50px;\n    padding: 0.75rem 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .auth-header {\n    padding: 1rem;\n    min-height: 80px;\n  }\n  \n  .auth-logo {\n    height: 40px;\n    width: 40px;\n    margin-bottom: 0.5rem;\n  }\n  \n  .auth-title {\n    font-size: 1.25rem;\n    margin-bottom: 0.25rem;\n  }\n  \n  .auth-subtitle {\n    font-size: 0.8rem;\n  }\n  \n  .auth-body {\n    padding: 1rem;\n  }\n  \n  .form-input {\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n  }\n  \n  .auth-body .btn-primary.btn-block,\n  .wizard-auth-content .btn-primary.btn-block {\n    padding: 0.625rem 0.875rem;\n    font-size: 0.8125rem;\n  }\n  \n  .social-buttons {\n    gap: 0.5rem;\n  }\n  \n  .remember-me-label {\n    font-size: 0.8rem;\n    line-height: 1.4;\n  }\n  \n  .btn-link {\n    font-size: 0.8rem;\n  }\n}\n\n/* Tablet landscape and larger phones */\n@media (min-width: 481px) and (max-width: 1024px) {\n  .auth-card {\n    max-width: 500px;\n  }\n  \n  .auth-left-section {\n    height: 100vh;\n  }\n  \n  .auth-right-section {\n    padding: 2rem;\n  }\n}\n\n/* Very small devices (phones under 360px) */\n@media (max-width: 360px) {\n  .auth-card {\n    max-height: 95vh;\n    margin: 1rem 0.5rem;\n    overflow-y: auto;\n  }\n  \n  .remember-me-label {\n    font-size: 0.75rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .auth-header {\n    padding: 0.75rem;\n    min-height: 70px;\n  }\n  \n  .auth-logo {\n    height: 35px;\n    width: 35px;\n    margin-bottom: 0.5rem;\n  }\n  \n  .auth-title {\n    font-size: 1.125rem;\n    margin-bottom: 0.25rem;\n  }\n  \n  .auth-subtitle {\n    font-size: 0.75rem;\n  }\n  \n  .auth-body {\n    padding: 0.75rem;\n  }\n  \n  .form-group {\n    margin-bottom: 0.75rem;\n  }\n  \n  .auth-body .btn-primary.btn-block,\n  .wizard-auth-content .btn-primary.btn-block {\n    font-size: 0.8125rem;\n    padding: 0.625rem 0.75rem;\n  }\n  \n  .social-buttons {\n    gap: 0.25rem;\n  }\n  \n  .social-btn {\n    padding: 0.5rem 0.25rem;\n    min-width: 45px;\n  }\n}\n\n/* Orientation-specific adjustments */\n@media screen and (orientation: landscape) and (max-width: 900px) {\n  .auth-container {\n    flex-direction: row;\n  }\n  \n  .auth-left-section {\n    display: none;\n  }\n  \n  .auth-right-section {\n    width: 100%;\n    padding: 1rem;\n  }\n  \n  .auth-card {\n    max-width: 400px;\n    margin: 0 auto;\n  }\n}\n\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 2rem 0;\n  gap: 0.5rem;\n  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\n}\n\n.pageNumbers {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.pageItem {\n  background: transparent;\n  color: #333;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95rem;\n  min-width: 40px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pageItem:hover:not(.active):not(.disabled) {\n  background: #f5f5f5;\n  border-color: #ccc;\n}\n\n.pageItem.active {\n  background: var(--color-secondary-dark);\n  color: var(--primary-color);\n  border-color: #0070f3;\n  font-weight: 500;\n  cursor: default;\n}\n\n.pageItem.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: transparent !important;\n}\n\n.navButton {\n  padding: 0.5rem 1rem;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.navButton:hover:not(.disabled) {\n  background: #e9ecef;\n}\n\n.chevron {\n  font-size: 1.1em;\n  margin: 0 2px;\n  color: var(--primary-color);\n}\n\n.pageDots {\n  padding: 0.5rem 0.25rem;\n  color: #6c757d;\n  display: flex;\n  align-items: flex-end;\n}\n\n@media (max-width: 768px) {\n  .pagination {\n    flex-wrap: wrap;\n    gap: 0.4rem;\n  }\n  \n  .pageItem {\n    padding: 0.4rem 0.6rem;\n    min-width: 36px;\n    font-size: 0.9rem;\n  }\n\n  .navButton {\n    padding: 0.4rem 0.8rem;\n  }\n}\n\n.center-loader {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--primary-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100%;\n}\n\n .form-group select.form-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 1rem;\n  padding-right: 2.5rem;\n}\n\n .dark .form-group select.form-input {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n}\n\n\n.entity-item {\n  position: relative; \n  padding: 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  background-color: #fff;\n  transition: all 0.2s ease;\n}\n\n.entity-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start; \n  margin-bottom: 8px;\n}\n\n.entity-name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  flex-grow: 1;\n}\n\n.entity-actions {\n  display: flex;\n  gap: 8px;\n  /* position: absolute; */\n  top: 10px;\n  right: 10px;\n}\n\n.action-btn {\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: #666;\n  transition: color 0.2s ease;\n}\n\n.action-btn:hover {\n  color: #333;\n}\n\n.action-btn.edit:hover {\n  color: #1a73e8;\n}\n\n.action-btn.delete:hover {\n  color: #d32f2f;\n}\n\n\n.status-badge {\n  margin-left: auto; \n}\n\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 15px;\n}\n\n.add-sprint-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-color);\n}\n\n.add-sprint-btn:hover {\n  color: #0d47a1;\n}\n\n/* React Toast Custom Styles */\n.toastContainer {\n  z-index: 20000 !important;\n  top: 80px !important;\n  position: fixed !important;\n  right: 20px !important;\n  left: auto !important;\n  width: auto !important;\n  max-width: 100vw !important;\n  overflow-x: hidden !important;\n}\n\n.toastContainer.top-right {\n  top: 80px !important;\n  right: 20px !important;\n  left: auto !important;\n  width: auto !important;\n  max-width: 100vw !important;\n  overflow-x: hidden !important;\n}\n\n.toast {\n  z-index: 9999 !important;\n  background: #28a745 !important;\n  color: white !important;\n  border-radius: 12px !important;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;\n  margin-bottom: 12px !important;\n  min-width: 320px !important;\n  max-width: 400px !important;\n  padding: 16px 20px !important;\n  border: none !important;\n  display: flex !important;\n  align-items: flex-start !important;\n  position: relative !important;\n  overflow: hidden !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;\n}\n\n.toast .icon {\n  margin-right: 12px !important;\n  flex-shrink: 0 !important;\n  width: 20px !important;\n  height: 20px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.toast .icon svg {\n  width: 18px !important;\n  height: 18px !important;\n  fill: white !important;\n}\n\n.toast .content {\n  flex: 1 !important;\n  padding: 0 !important;\n  margin: 0 12px 0 0 !important;\n}\n\n.toast .content p {\n  margin: 0 !important;\n  padding: 0 !important;\n  color: white !important;\n  font-size: 14px !important;\n  line-height: 1.5 !important;\n  font-weight: 500 !important;\n}\n\n/* Close button styling */\n.toast .close {\n  flex-shrink: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  border-radius: 50% !important;\n  transition: all 0.2s ease !important;\n  background: rgba(255, 255, 255, 0.1) !important;\n  margin-left: 8px !important;\n}\n\n.toast .close:hover {\n  background: rgba(255, 255, 255, 0.2) !important;\n}\n\n.toast .close svg {\n  width: 14px !important;\n  height: 14px !important;\n  fill: rgba(255, 255, 255, 0.8) !important;\n}\n\n.toast .close:hover svg {\n  fill: white !important;\n}\n\n/* Success Toast */\n.toast.success {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;\n}\n\n/* Error Toast */\n.toast.error {\n  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%) !important;\n}\n\n/* Warning Toast */\n.toast.warning {\n  background: linear-gradient(135deg, #ffc107 0%, #f39c12 100%) !important;\n  color: #333 !important;\n}\n\n.toast.warning .content p {\n  color: #333 !important;\n}\n\n.toast.warning .icon svg {\n  fill: #333 !important;\n}\n\n.toast.warning .close {\n  background: rgba(0, 0, 0, 0.1) !important;\n}\n\n.toast.warning .close:hover {\n  background: rgba(0, 0, 0, 0.2) !important;\n}\n\n.toast.warning .close svg {\n  fill: rgba(0, 0, 0, 0.6) !important;\n}\n\n.toast.warning .close:hover svg {\n  fill: #333 !important;\n}\n\n/* Info Toast */\n.toast.info {\n  background: linear-gradient(135deg, #17a2b8 0%, #3498db 100%) !important;\n}\n\n/* Default Toast */\n.toast.default {\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;\n}\n\n/* Slide-in animation */\n.toast {\n  animation: slideInRight 0.3s ease-out !important;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%) !important;\n    opacity: 0 !important;\n  }\n  to {\n    transform: translateX(0) !important;\n    opacity: 1 !important;\n  }\n}\n\n/* Slide-out animation */\n.toast.toast-exit {\n  animation: slideOutRight 0.3s ease-in !important;\n}\n\n@keyframes slideOutRight {\n  from {\n    transform: translateX(0) !important;\n    opacity: 1 !important;\n  }\n  to {\n    transform: translateX(100%) !important;\n    opacity: 0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
